import * as React from 'react';
import { connect } from 'react-redux';
import * as AlertModule from 'Modules/AlertModule';
import * as FleetModule from 'Modules/FleetModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import { ActionDetailsIcon } from 'HelperFunctions/DetailsSidebarHelpers';
import {submit} from 'redux-form';
import {resetCacheFormValues} from "Redux/Actions/FleetActions";

type P = {
    history?: any;
    edit: boolean;
    match?: any;
};
type ConnectedP = {
    alertStore: AlertModule.Types.AlertStore;
};
type DispatchedP = {
    showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
    t?: (key: string) => string;
    fleetFormSubmit: () => void;
    deleteFleet: (fleetId: number) => void;
    setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => void;
    resetCacheFormValues: () => void;
};
type S = {};

class ManageFleetDetails extends React.Component<P & ConnectedP & DispatchedP, S> {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
    }

    private async handleFleetDelete() {
        const { showPopup, deleteFleet, match, setActiveFleet } = this.props;
        const { PopupType } = ViewManagementModule.VMEnumTypes;
        showPopup({
            type: PopupType.DELETE_FLEET,
            confirmCallback: async () => {
                await deleteFleet(match.params.fleetId);
                setActiveFleet(null);
                this.props.history.push(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.FLEET));
            }
        });
    }

    public render() {
        const { t } = this.props;
        return (
            <div className="details-right__dashboard">
                <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('forms:saveFleet')} onClick={() => this.props.fleetFormSubmit()} />
                {this.props.match.params.fleetId !== 'add' && <ActionDetailsIcon active={true} iconSrc={`/images/icons/garbage.svg`} title={t('delete')} onClick={() => this.handleFleetDelete()} />}
                <ActionDetailsIcon
                    active
                    iconSrc={`/images/icons/addSign.svg`}
                    title={t('forms:cancel')}
                    rotate
                    onClick={() => {
                      this.props.resetCacheFormValues()

                      return this.props.history.push(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.FLEET));
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        alertStore: state.alertStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        fleetFormSubmit: () => dispatch(submit('AddFleet')),
        deleteFleet: (fleetId: number) => dispatch(FleetModule.Actions.deleteFleet(fleetId)),
        setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => dispatch(FleetModule.Actions.setActiveFleet(fleet)),
        resetCacheFormValues: () => dispatch(resetCacheFormValues())
    };
}
export default withTranslation (['carDetails', 'forms'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ManageFleetDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ManageFleetDetails.tsx